export default __webpack_public_path__ + "static/media/willowwood.cd0dc988.PNG";